module.exports = __webpack_public_path__ + "img/MGH-Gion-11.e9116bb9.jpg";